import {  memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';

// i18next
import i18n from 'i18next';
// import { useTranslation } from 'react-i18next';

// @mui
import { Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// components
import { SvgBellFill } from '../../components/SvgIcons';
import { toggleNotificationListDrawer } from '../../store/actions/slices/notificationActions';

import { IconPopover } from '../@popover/IconPopover';

/* ======================================================================================= */


const NotificationPopover = ({ color = `#FFFFFF`, position = { x: '-28px' }, text = false, icon = false }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { notification } = useSelector(state => state?.slices); 
    return (
      <IconPopover
        position={position}
        primary={
          <Stack direction={'row'} alignItems={`center`} onClick={() => dispatch(toggleNotificationListDrawer(true))}>
            <SvgBellFill variant={notification?.existAllNotification > 0 ? 'outlined' : 'contained' } color={theme.palette.common.white} />
          </Stack>
        }
      />
    );
};

export default memo(NotificationPopover);
